import styled from 'styled-components';
import {
  whiteColor,
  screenSize,
  appFontColor,
  mediumFont,
  regularFont,
  primaryColor,
  secondaryColor,
  secondaryHoverColor,
} from '@app/styles';

type Props = {
  disabled: boolean;
};
export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  margin-top: 65px;
  @media (${screenSize.tablet}) {
    display: flex;
    align-items: center;
    background-position: 0 -2px;
    margin-top: 55px;
  }
`;

export const InnerContainer = styled.div`
    width:100%;
    position:relative;
    padding:15px;
    @media (${screenSize.tablet}){
        width: 500px;
        height:420px;
        padding: 70px 35px 25px;
        margin: 0 auto;
        box-shadow: rgb(100 112 119 / 20%) 0px 5px 10px 0px;
        background-color: ${whiteColor};       
        border-radius:8px;
        z-index: 1;  
    }
    ${({ disabled }: Props) => {
      if (disabled) {
        return `
        pointer-events:none;
        button{
          position:relative;
          background-color:#858f96;
        }`;
      }
    }}
  }
`;
export const ResetContainer = styled.div`
    width:100%;
    position:relative;
    padding:15px;
    @media (${screenSize.tablet}){
        width: 550px;
        height:340px;
        padding: 70px 35px 25px;
        margin: 0 auto;
        background-color: ${whiteColor};       
        border: 1px solid #e3e5e9;
        border-radius:8px;
        z-index: 1;  
    }
    ${({ disabled }: Props) => {
      if (disabled) {
        return `
        pointer-events:none;
        button{
          position:relative;
          background-color:#858f96;
        }`;
      }
    }}
  }
`;
export const Heading = styled.div`
  font-size: 21px;
  color: #3a435e;
  ${mediumFont}
  text-align: center;
  margin: 30px auto;
  @media (${screenSize.tablet}) {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    margin: 0 auto;
    border-bottom: 1px solid #dce0e8;
  }
`;
export const Text = styled.div`
  display: none;
  @media (${screenSize.tablet}) {
    font-size: 16px;
    color: #3a435e;
    text-align: center;
    line-height: 30px;
    margin: 20px auto;
  }
`;
export const MobileText = styled.div`
  font-size: 16px;
  color: #3a435e;
  text-align: center;
  line-height: 30px;
  margin: 20px auto;
  @media (${screenSize.tablet}) {
    display: none;
  }
`;
export const AccountText = styled.div`
  font-size: 15px;
  color: #6b6f8c;
  text-align: center;
  line-height: 24px;
  margin: 20px auto;
  ${regularFont};
  a {
    ${regularFont};
  }
`;
export const ResetText = styled.p`
  color: ${appFontColor};
  ${regularFont};
  text-align: center;
  line-height: 36px;
  font-size: 18px;
  opacity: 0.5;
  margin: 15px auto;
`;
export const EmailText = styled.p`
  color: ${primaryColor};
`;
export const ErrorMessage = styled.p`
         font-size: 14px;
         ${regularFont};
         color: #ec4160;
         margin: 0;
         position: relative;
         bottom: 8px;
         height: 14px;
       `;
export const ResendText = styled.span`
  ${regularFont};
  font-size: 16px;
  color: ${secondaryColor};
  cursor: pointer;
  &:hover {
    color: ${secondaryHoverColor};
  }
`;
export const SavingIndicator = styled.div`
  position: absolute;
  right: 30px;
  top: 16px;
`;
